import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // You can clone the response and modify headers if necessary
          const clonedResponse = event.clone({
            headers: event.headers.set('Cache-Control', 'no-store').set("Strict-Transport-Security", "max-age=31536000; includeSubDomains").set("Content-Security-Policy", "script-src")
          });

          // Return the cloned response with the new headers
          return clonedResponse;

        }
      })
    );
  }
}
